/* ---- Fixed Connectors (Hintergrundgrafiken) --------------- */
(function () {
  function makeConn(src, posClass, colorClass) {
    var img = document.createElement('img');
    img.src = src;
    img.className = 'cc-pconn ' + posClass + ' ' + colorClass;
    img.setAttribute('aria-hidden', 'true');
    document.body.appendChild(img);
    return img;
  }

  // WebP statt PNG (statische Einmal-Konvertierung, 2026-09-05, verlustfrei) - ca. 51% kleiner bei
  // dieser Art Linien-/Alpha-Grafik, siehe connector-left-white.png/.webp im selben Verzeichnis
  // (Original bewusst nicht geloescht).
  var connectorLeft = '/fileadmin/user_upload/bilder/connector-left-white.webp';
  var connectorRight = '/fileadmin/user_upload/bilder/connector-right-white.webp';

  // Ebene 1: hellgrau (für weiße Bereiche)
  var grayL  = makeConn(connectorLeft,  'cc-pconn--l', 'cc-pconn--on-white');
  var grayR  = makeConn(connectorRight, 'cc-pconn--r', 'cc-pconn--on-white');
  // Ebene 2: weiß, per clip-path auf graue Sections begrenzt
  var whiteL = makeConn(connectorLeft,  'cc-pconn--l', 'cc-pconn--on-gray');
  var whiteR = makeConn(connectorRight, 'cc-pconn--r', 'cc-pconn--on-gray');

  var all = [grayL, grayR, whiteL, whiteR];
  var ticking = false;

  // Startpunkt auf der Startseite: unterhalb der Stats-Bar (schwarzer Zahlenbalken)
  function heroClipTop(el) {
    var stats = document.querySelector('.cc-stats-bar');
    if (!stats) return 0;
    var elRect    = el.getBoundingClientRect();
    var statsRect = stats.getBoundingClientRect();
    return Math.max(0, statsRect.bottom - elRect.top);
  }

  // Clip für graue Ebene: nur Hero (+ Stats-Bar) ausblenden
  function calcGrayClip(el) {
    var topClip = heroClipTop(el);
    return topClip > 0 ? 'inset(' + topClip + 'px 0px 0px 0px)' : 'none';
  }

  // Clip für weiße Ebene: Hero + nur über grauen Sections sichtbar
  function calcWhiteClip(el) {
    var elRect   = el.getBoundingClientRect();
    var topHero  = heroClipTop(el);
    var graySections = document.querySelectorAll('.cc-section--gray');
    var clipTop = elRect.height, clipBottom = elRect.height;

    graySections.forEach(function (s) {
      var sr = s.getBoundingClientRect();
      if (sr.bottom > elRect.top && elRect.bottom > sr.top) {
        clipTop    = Math.max(topHero, sr.top    - elRect.top);
        clipBottom = Math.max(0,       elRect.bottom - sr.bottom);
      }
    });

    return 'inset(' + clipTop + 'px 0px ' + clipBottom + 'px 0px)';
  }

  function update() {
    grayL.style.clipPath  = calcGrayClip(grayL);
    grayR.style.clipPath  = calcGrayClip(grayR);
    whiteL.style.clipPath = calcWhiteClip(whiteL);
    whiteR.style.clipPath = calcWhiteClip(whiteR);
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });

  all.forEach(function (el) { el.classList.add('is-visible'); });
  document.addEventListener('DOMContentLoaded', function () {
    requestAnimationFrame(update);
  });
}());
